import {Group} from "../../lib/types";
import {useUserContext} from "../../providers/UserContext";

export const MembersModal = ({ group }: { group: Group }) => {
  const {activeWorkspace} = useUserContext();
  const members = activeWorkspace?.members ? Object.values(activeWorkspace.members) : [];
  const groupMembers = members.filter(member => group.permissions[member.id] || group.visibility === 'public');

  return (
    <div>
      <div className="members justify-start text-left   ">
        <h2>Members of {group.emoji} {group.name}</h2>

        <div className="flex flex-col gap-4 mt-4">
          {groupMembers.map(member => (
            <div key={member.id} className="flex items-center gap-2">
              <div className="avatar rounded-full bg-gray-3">
                <img src={member.avatar} alt={member.displayName} className={"w-6 h-6 rounded-full"}/>
              </div>
              <div className="flex flex-col font-style-body-md">
                <div>
                  {member.displayName}
                  <span className="font-style-body-xs text-gray-3 ml-2">
                    {group.permissions[member.id] === 'admin' ? '(admin)' : ''}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}